module.exports = __webpack_public_path__ + "img/word.bf669fd1.png";